module.exports = __webpack_public_path__ + "img/mt5.2bd40cfe.jpg";